import { t } from 'utils/localization';
import _capitalize from 'lodash/capitalize';
import _unique from 'lodash/uniq';
import _uniqueBy from 'lodash/uniqBy';
import _pick from 'lodash/pick';
import _compact from 'lodash/compact';

export const stateNameMapper = (state) => {
  return state && t(`Orders.Order.Passenger.Statuses.${_capitalize(state)}`);
};

export const airportShortInfo = (airport) => {
  if (!airport) {
    return '';
  }

  const { name, iata_code, terminal } = airport;

  return _compact([name, iata_code, terminal && `терминал ${terminal}`]).join(', ');
};

export const legToFlightsClasses = ({ segments }) => {
  const classes = _unique(segments?.map(({ class_type }) => class_type?.name));

  const flights =
    segments &&
    _uniqueBy(segments, 'flight_number')?.reduce((total, current) => {
      if (current?.air_company?.code && current?.flight_number) {
        return [...total, _pick(current, ['air_company', 'flight_number'])];
      }

      return total;
    }, []);

  return {
    classes,
    flights,
  };
};

export const orderItemTypes = {
  AVIA: 'Avia::OrderItem',
  HOTEL: 'Hotel::OrderItem',
  RGD: 'RGD::OrderItem',
};

export const orderItemTypesToCyrillic = {
  [orderItemTypes.HOTEL]: 'Отель',
  [orderItemTypes.AVIA]: 'Авиа',
  [orderItemTypes.RGD]: 'Ж/д',
};
